import * as types from '../costants/ActionTypes';
import {CLEAR_FAVORITE_URL, CLEAR_FAVORITE_GROUP_URL, FAVORITE_URL, CART_URL} from "../costants/Urls";
import axios from 'axios';


export const setFavoriteState = status => ({
    type: types.SET_FAV_STATE,
    status
});

export const setFavoriteGroup = group => ({
    type: types.SET_FAV_GROUP,
    group
});

export const addGroup = group => ({
    type: types.ADD_FAV_GROUP,
    group
});

export const setFavoriteData = data => ({
    type: types.SET_FAV_DATA,
    data
});

export const resetFavoriteData = data => ({
    type: types.RESET_FAV_DATA,
    data
});

export const setFavoriteItemData = data => ({
    type: types.SET_FAV_ITEM_DATA,
    data
});

export const setFavoritePage = page => ({
    type: types.SET_FAV_PAGE,
    page
});

export const setAddToCart = (sku, group) => ({
    type: types.SET_ADD_TO_CART,
    sku,
    group
});

export const setAllAddToCart = () => ({
    type: types.SET_ALL_ADD_TO_CART,
});

export const clearReqParams = () => ({
    type: types.CLEAR_REQ_PARAMS
})

export const clearState = () => ({
    type: types.CLEAR_STATE
})

const post_config = {
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
    withCredentials: true
}


// Обновление данных элементов корзины
export const fetchFavoriteItems = status =>  (dispatch, getState) => {

    const prev_state = getState()
    const loading_state = prev_state.favorite.status;

    let url = FAVORITE_URL;
    let params = [];

    if (prev_state.favorite.group.length > 0){
        params.push('group=' + prev_state.favorite.group);
    }
    if (prev_state.favorite.page !== 1){
        params.push('page=' + prev_state.favorite.page);
    }
    let tm = new Date().getTime();
    params.push('ch=' + tm);

    if(params.length > 0){
        url = url + '?'+ params.join('&');
    }

    if (loading_state==="NOT_LOADED"){

        dispatch(setFavoriteState('FETCHING'));

        axios.get(url, {}).then(res => {
            if (res.status === 200 || res.status === 201){
                dispatch(setFavoriteData(res.data));
                dispatch(setFavoriteState('READY'));
            }else{
                dispatch(setFavoriteState('ERROR'));
            }
          }).catch(err => {
              dispatch(setFavoriteState('ERROR'));
          });
    }
};

// Очистка корзины
export const clearFavorite = () =>  (dispatch, getState) => {

  const url = CLEAR_FAVORITE_URL;
  const loading_state = getState().favorite.status;

  if (loading_state==='READY'){

      dispatch(setFavoriteState('FETCHING'));

      axios.delete(url, post_config).then( res => {
         if (res.status === 200 || res.status === 204){
             dispatch(clearState());
             dispatch(setFavoriteState('READY'));
         }else{
             dispatch(setFavoriteState('ERROR'));
         }
      }).catch(err=> {
            dispatch(setFavoriteState('ERROR'));
      });
  };

};

export const delFavoriteGroup = (group) =>  (dispatch, getState) => {

  const url = CLEAR_FAVORITE_GROUP_URL;
  const loading_state = getState().favorite.status;

  if (loading_state==='READY'){

      dispatch(setFavoriteState('FETCHING'));
      const data = Object.assign({}, {data: {group: group}}, post_config);

      axios.delete(url, data).then( res => {
         if (res.status === 200 || res.status === 204){
             dispatch(clearReqParams());
             dispatch(fetchFavoriteItems());
         }else{
             dispatch(setFavoriteState('ERROR'));
         }
      }).catch(err=> {
          dispatch(setFavoriteState('ERROR'));
      });
  };

};

// Удаление элемента корзины
export const delFavoriteItem = productId => (dispatch, getState) => {

  const prev_state = getState();
  const productItem = prev_state.favorite.items.find(x => x.id === productId);

  if ((productItem !== undefined)&&(prev_state.favorite.status==="READY")) {

    let url = FAVORITE_URL + productItem.id + '/';
    if (prev_state.favorite.group.length > 0){
        url = url + '?group=' + prev_state.favorite.group;
    }

    dispatch(setFavoriteState('FETCHING'));

    axios.delete(url, post_config).then( res => {
         if (res.status === 200 || res.status === 204){
             dispatch(clearReqParams());
             dispatch(fetchFavoriteItems());
         }else{
             dispatch(setFavoriteState('ERROR'));
         }
    }).catch(err=> {
        dispatch(setFavoriteState('ERROR'));
    });
  }
}


// Обновление количества товара
export const updateItemQuantity = (product, quantity) => (dispatch, getState) => {

    const url = FAVORITE_URL + product.id + '/';
    dispatch(setFavoriteState('FETCHING'));

    axios.patch(url, {'quantity': quantity}, post_config).then( res => {
        if (res.status === 200 || res.status === 201){
            dispatch(setFavoriteItemData(res.data));
            dispatch(setFavoriteState('READY'));
        }else{
            dispatch(setFavoriteItemData('ERROR'));
        }
    }).catch(err=> {
        dispatch(setFavoriteItemData('ERROR'));
    });
}


export const updateItemGroup = (product, group) => (dispatch, getState) => {

    const url = FAVORITE_URL + product.id + '/';
    const current_groups = getState().favorite.groups;

    dispatch(setFavoriteState('FETCHING'));

    axios.patch(url, {'group': group}, post_config).then( res => {
        if (res.status === 200 || res.status === 201){
            dispatch(setFavoriteItemData(res.data));
            if(current_groups.indexOf(group) < 0 ){
                dispatch(addGroup(group));
            }
            dispatch(setFavoriteState('READY'));
        }else{
            dispatch(setFavoriteItemData('ERROR'));
        }
    }).catch(err=> {
        dispatch(setFavoriteItemData('ERROR'));
    });
}


// Изменение активности товара
export const checkFavoriteItem = (productId, checked) => (dispatch, getState) => {

    const prev_state = getState();
    const productItem = prev_state.favorite.items.find(x => x.id === productId);

    if ((productItem !== undefined) && (productItem.checked !== checked) && (prev_state.favorite.status === "READY")) {

        const url = FAVORITE_URL + productItem.id + '/';
        dispatch(setFavoriteState('FETCHING'));

        axios.patch(url, {'checked': checked}, post_config).then( res => {
            if (res.status === 200 || res.status === 201){
                dispatch(setFavoriteItemData(res.data));
                dispatch(setFavoriteState('READY'));
            }else{
                dispatch(setFavoriteState('ERROR'));
            }
        }).catch(err=> {
            dispatch(setFavoriteState('ERROR'));
        });
    }
}


export const addAllToCart = () => (dispatch, getState) =>{

    const url = CART_URL + '?many=true';
    const loading_state = getState().favorite.status;

    if (loading_state==='READY'){

        let success= true;

        const checked_items = getState().favorite.items.filter(item => {return item.checked});
        if (checked_items.length > 0){
            const data = checked_items.map( product => { return {
                  "app": product.item_app,
                  "id": product.sku,
                  "quantity": product.quantity,
                  "data": product.extra.app_data
                }});
            dispatch(setFavoriteState('FETCHING'));
            axios.post(url, data, post_config).then( res => {
                if (res.status === 200 || res.status === 201){
                    dispatch(setAllAddToCart());
                }else{
                    success = false;
                    dispatch(setFavoriteState('ERROR'));
                }
            }).catch(err=> {
                success = false;
                dispatch(setFavoriteState('ERROR'));
            });

        }else{
            success = false;
        };

        if (success ){
            dispatch(setFavoriteState('READY'));
            let updateEvent = new CustomEvent("NcartNeedUpdate", {detail: "addfromfavorite"});
            document.dispatchEvent(updateEvent);
        };
    }
}

export const addToCart = (product) =>  (dispatch, getState) => {

  const url = CART_URL;
  const loading_state = getState().favorite.status;
  const data = {
      "app": product.item_app,
      "id": product.sku,
      "quantity": product.quantity,
      "data": product.extra.app_data
  }

  if (loading_state==='READY'){

      dispatch(setFavoriteState('FETCHING'));

      axios.post(url, data, post_config).then( res => {
         if (res.status === 200 || res.status === 201){
             dispatch(setAddToCart(product.sku, product.group));
             dispatch(setFavoriteState('READY'));
             let updateEvent = new CustomEvent("NcartNeedUpdate", {detail: "addfromfavorite"});
             document.dispatchEvent(updateEvent);
         }else{
             dispatch(setFavoriteState('ERROR'));
         }
      }).catch(err=> {
          dispatch(setFavoriteState('ERROR'));
      })
  };
};